import { render } from "./IpInfoDetail.vue?vue&type=template&id=3502b4cb&scoped=true"
import script from "./IpInfoDetail.vue?vue&type=script&lang=js"
export * from "./IpInfoDetail.vue?vue&type=script&lang=js"

import "./IpInfoDetail.vue?vue&type=style&index=0&id=3502b4cb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3502b4cb"]])

export default __exports__